import {
  // BackButtonWText,
  CustomDatePicker,
  CustomTextInput,
  InfiniteScrollerCustom,
  NoResults,
  SnackBar,
  //TableItemCard,
  TabHeading,
  Wrapper,
} from 'Components';
import React, {Fragment, useEffect, useState} from 'react';
import {TRANSACTIONSLOG} from './transactionLogConstants';
import RefreshButton from 'Components/RefeshButton';
import {useCSContext} from 'Context/ContentStackContext';
import {Card, Flex, Skeleton, theme, Typography} from 'antd';
import {useInfiniteScroll, useSnackBar} from 'Hooks';
import {useDispatch, useSelector} from 'react-redux';
import {format, isDate} from 'date-fns';
import {DATE_FORMAT} from 'Utils/constants/DateFormat';
import {useLocation} from 'react-router-dom';
import {getAllClaimedOffer} from 'Redux/Slices/transactionDashboardList';
import TransactionDetails from './transactionDetails';
import {CDP_ALLOWED_TENANT_ID} from 'Utils/constants/genericConstants';

const TabTransactionLogs = () => {
  const {artifacts} = useCSContext();
  const {token} = theme.useToken();
  const location: any = useLocation();
  const state = location?.state;
  const [deatilView, setDetailView] = useState<boolean>(false);
  const [selectedTransaction, setSelectedTransaction] = useState<any>({});
  const [transactions, setTransactions] = useState<any[]>([]);
  const [selectedOffer, setSelectedOffer] = useState<any>({});
  const loginDetails = useSelector((state: any) => state?.login);
  const {selectedMember} = useSelector((state: any) => state?.selectedMember);
  const dispatch = useDispatch();
  const {txnOfferTypes} = useSelector((state: any) => state?.login?.tenantConfig);

  const txn = ['Select All', ...txnOfferTypes.split(',').map((offer) => offer.trim())];
  const [filterByType, setFilterByType] = useState(txn[0]);
  const [filterByDate, setFilterByDate] = useState(null);
  const [error, setError] = useState(null);
  const [totalResults, setTotalResults] = useState(0);
  const [{pageNo, nextPage, resetPage, pageSize}] = useInfiniteScroll();
  const [isSnackBarOpen, closeSnackBar] = useSnackBar(error);

  const [loading, setLoading] = useState(true);
  const [refreshFetch, setRefreshFetch] = useState(false);
  const allowedOfferTypes = [
    'instantwin',
    'reward',
    'prizedraw',
    'giftcard',
    'voucher',
    'cashback',
    'travel',
    'cardlinked',
  ];
  // const [error, setError] = useState(null);
  // const [isSnackBarOpen, closeSnackBar] = useSnackBar(error);
  // const [transactions, setTransactions] = useState<any[]>([]);
  //const [{resetPage}] = useInfiniteScroll();
  const transactionList = useSelector(
    (state: any) => state?.transactionLogList?.transactionslogList,
  );
  //console.log(transactionList);
  //methods used in useeffect
  const _showLoading = () => pageNo === 0 && setLoading(true);
  const _handleResponse = (data, loading, error) => {
    setLoading(loading);
    if (error) {
      setError(error.message);
    } else {
      if (data) {
        const {pagingInfo, claimedOffers} = data;
        pageNo === 0 && setTotalResults(pagingInfo?.totalResults);
        claimedOffers && pageNo === 0
          ? setTransactions(claimedOffers)
          : setTransactions([...transactions, ...claimedOffers]);
      }
    }
  };

  //console.log(state?.selectedOffer?.id);
  useEffect(() => {
    if (state?.selectedClaim?.id) {
      // handleSRRowClick();
      // showTransactionDetails(state?.selectedClaim);
      setDetailView(true);
      setSelectedTransaction(state?.selectedClaim);
      state.selectedClaim = null;
    }
    if (state?.selectedOffer?.id) {
      setDetailView(true);
      setSelectedOffer(state?.selectedOffer); // Set the selected offer
      state.selectedOffer = null; // Reset the selectedOffer in state
    }
  }, [state]);

  // const transactionList = [];
  useEffect(() => {
    if (refreshFetch) {
      (async () => {
        /*setLoading(true);
        let payload = {
          tenantId: loginDetails?.tenantID,
          userId: selectedMember?.currentMemberDetails?.userId,
          customerId:
            selectedMember?.currentMemberDetails?.memberId ??
            selectedMember?.currentMemberDetails?.userId,
          userGroupId: selectedMember?.membershipId,
          pageNumber: 0,
          pageSize: 100,
        };
        await dispatch(getAllClaimedOffer(payload)).unwrap();
        setRefreshFetch(false);
        setLoading(false);*/
        const {data, loading, error} = await dispatch(
          getAllClaimedOffer({
            tenantId: loginDetails?.tenantID,
            userId: selectedMember?.currentMemberDetails?.userId,
            ...(CDP_ALLOWED_TENANT_ID.includes(String(loginDetails?.tenantID))
              ? {
                  customerId: selectedMember?.currentMemberDetails?.memberId ?? null,
                }
              : {
                  customerId:
                    selectedMember?.currentMemberDetails?.memberId ??
                    selectedMember?.currentMemberDetails?.userId,
                }),
            userGroupId: selectedMember?.membershipId,
            pageSize: pageSize,
            pageNumber: pageNo,
          }),
        ).unwrap();
        _handleResponse(data?.getAllClaimedOffer?.[0], loading, error);
        setRefreshFetch(false);
      })();
    }
  }, [refreshFetch, pageNo, pageSize]);

  const refresh = () => {
    setRefreshFetch(true);
    resetPage();
    setFilterByType(txn[0]);
    setFilterByDate(null);
  };

  //get Status text based on Text
  const getStatusText = (status) => {
    if (!status) return '';

    const formattedStatus = status.toLowerCase().trim();

    if (formattedStatus === 'winner') return 'Winner';
    if (formattedStatus === 'loser') return "We're Sorry";

    return formattedStatus; // Default to original status if it's neither "winner" nor "loser"
  };

  const renderLogCard = () => {
    if (transactions?.length) {
      return transactions?.map((item: any, index: number) => {
        // Find the corresponding offer in the `offers` array
        const selectedOffer = transactionList?.offers?.find(
          (offer: any) => offer.id === item.offerId,
        );

        // Helper function to determine the title
        const getCardTitle = (item: any, selectedOffer: any) => {
          const offerType = item?.offerType?.toLowerCase()?.trim();
          //console.log(offerType);
          if (allowedOfferTypes.includes(offerType)) {
            return selectedOffer?.title;
          }
          /*else if (offerType === 'event') {
            return (
              item?.data?.claimDetails?.eventName?.trim() ||
              item?.data?.claimDetails?.orderData?.data?.orderId
            );
          }*/
          return (
            item?.data?.claimDetails?.eventName?.trim() ||
            item?.data?.claimDetails?.orderData?.data?.orderId
          );
        };
        //console.log(selectedOffer, item?.data?.claimDetails?.eventName?.trim());
        return (
          <Card
            hoverable
            onClick={() => {
              setDetailView(true);
              setSelectedTransaction(item);
              setSelectedOffer(selectedOffer); // Set the corresponding offer
            }}
            style={{borderColor: token.colorBorderSecondary, marginTop: 16}}>
            <Typography.Title
              level={4}
              style={{color: token.colorPrimary, wordBreak: 'break-word', marginBottom: 4}}>
              {getCardTitle(item, selectedOffer)}
            </Typography.Title>

            <Flex gap="5%">
              {/* claim and expiry */}
              <Flex vertical justify="space-between" style={{width: '40%'}}>
                <Typography.Text>
                  <strong>{TRANSACTIONSLOG.card_field_map.claimDate} </strong>

                  {item.claimDateTime &&
                    isDate(new Date(item.claimDateTime)) &&
                    format(new Date(item.claimDateTime), DATE_FORMAT.dateFormat)}
                </Typography.Text>
                {/* TODO this field might change name in backend to offerenddate for transactions*/}

                <Typography.Text>
                  <strong>{TRANSACTIONSLOG.card_field_map.expiryDate} </strong>
                  {item.expiryDateTime &&
                    isDate(new Date(item.expiryDateTime)) &&
                    format(new Date(item.expiryDateTime), DATE_FORMAT.dateFormat)}
                </Typography.Text>
              </Flex>
              {/* vendor name */}
              <Flex vertical style={{width: '20%'}}>
                <Typography.Text>
                  {allowedOfferTypes.includes(item?.offerType?.toLowerCase()?.trim())
                    ? selectedOffer?.merchant?.name
                    : item?.data?.claimDetails?.merchantName}
                </Typography.Text>
              </Flex>

              {/* type and status */}
              <Flex vertical>
                <Typography.Text>
                  {TRANSACTIONSLOG.card_field_map.type}{' '}
                  <strong style={{textTransform: 'capitalize'}}>{item.offerType}</strong>
                </Typography.Text>

                <Typography.Text>
                  {TRANSACTIONSLOG.card_field_map.status}{' '}
                  <strong style={{textTransform: 'capitalize'}}>
                    {item?.offerType?.toLowerCase()?.trim() === 'instantwin'
                      ? getStatusText(item?.status)
                      : item?.status}
                  </strong>
                </Typography.Text>
              </Flex>
            </Flex>
          </Card>
        );
      });
    } else {
      return <NoResults text={TRANSACTIONSLOG.no_results_text} />;
    }
  };

  useEffect(() => {
    _showLoading();
    if (!filterByDate) {
      if (filterByType === txn[0]) {
        (async () => {
          /*setLoading(true);
          let payload = {
            tenantId: loginDetails?.tenantID,
            userId: selectedMember?.currentMemberDetails?.userId,
            customerId:
              selectedMember?.currentMemberDetails?.memberId ??
              selectedMember?.currentMemberDetails?.userId,
            userGroupId: selectedMember?.membershipId,
            pageNumber: 0,
            pageSize: 100,
          };
          await dispatch(getAllClaimedOffer(payload)).unwrap();
          setLoading(false);*/
          const {data, loading, error} = await dispatch(
            getAllClaimedOffer({
              tenantId: loginDetails?.tenantID,
              userId: selectedMember?.currentMemberDetails?.userId,
              ...(CDP_ALLOWED_TENANT_ID.includes(String(loginDetails?.tenantID))
                ? {
                    customerId: selectedMember?.currentMemberDetails?.memberId ?? null,
                  }
                : {
                    customerId:
                      selectedMember?.currentMemberDetails?.memberId ??
                      selectedMember?.currentMemberDetails?.userId,
                  }),
              userGroupId: selectedMember?.membershipId,
              pageSize: pageSize,
              pageNumber: pageNo,
            }),
          ).unwrap();
          _handleResponse(data?.getAllClaimedOffer?.[0], loading, error);
        })();
      } else {
        //if filter != show all
        (async () => {
          /*setLoading(true);
          let payload = {
            tenantId: loginDetails?.tenantID,
            userId: selectedMember?.currentMemberDetails?.userId,
            customerId:
              selectedMember?.currentMemberDetails?.memberId ??
              selectedMember?.currentMemberDetails?.userId,
            userGroupId: selectedMember?.membershipId,
            offerType: filterByType,
            pageNumber: 0,
            pageSize: 100,
          };
          await dispatch(getAllClaimedOffer(payload)).unwrap();
          setLoading(false);*/
          const {data, loading, error} = await dispatch(
            getAllClaimedOffer({
              tenantId: loginDetails?.tenantID,
              userId: selectedMember?.currentMemberDetails?.userId,
              ...(CDP_ALLOWED_TENANT_ID.includes(String(loginDetails?.tenantID))
                ? {
                    customerId: selectedMember?.currentMemberDetails?.memberId ?? null,
                  }
                : {
                    customerId:
                      selectedMember?.currentMemberDetails?.memberId ??
                      selectedMember?.currentMemberDetails?.userId,
                  }),
              userGroupId: selectedMember?.membershipId,
              offerType: filterByType,
              pageSize: pageSize,
              pageNumber: pageNo,
            }),
          ).unwrap();
          _handleResponse(data?.getAllClaimedOffer?.[0], loading, error);
        })();
      }
    } else {
      //Filter by date only (type = show all)
      if (filterByDate && filterByType === txn[0]) {
        //filterByDate (it's already formatted in datepicker onchange)
        (async () => {
          /*setLoading(true);
          let payload = {
            tenantId: loginDetails?.tenantID,
            userId: selectedMember?.currentMemberDetails?.userId,
            customerId:
              selectedMember?.currentMemberDetails?.memberId ??
              selectedMember?.currentMemberDetails?.userId,
            userGroupId: selectedMember?.membershipId,
            transactionDate: format(new Date(filterByDate), 'yyyy-MM-dd'),
            pageNumber: 0,
            pageSize: 100,
          };
          await dispatch(getAllClaimedOffer(payload)).unwrap();
          setLoading(false);*/
          const {data, loading, error} = await dispatch(
            getAllClaimedOffer({
              tenantId: loginDetails?.tenantID,
              userId: selectedMember?.currentMemberDetails?.userId,
              ...(CDP_ALLOWED_TENANT_ID.includes(String(loginDetails?.tenantID))
                ? {
                    customerId: selectedMember?.currentMemberDetails?.memberId ?? null,
                  }
                : {
                    customerId:
                      selectedMember?.currentMemberDetails?.memberId ??
                      selectedMember?.currentMemberDetails?.userId,
                  }),
              userGroupId: selectedMember?.membershipId,
              transactionDate: format(new Date(filterByDate), 'yyyy-MM-dd'),
              pageSize: pageSize,
              pageNumber: pageNo,
            }),
          ).unwrap();
          _handleResponse(data?.getAllClaimedOffer?.[0], loading, error);
        })();
      }
      if (filterByDate && filterByType !== txn[0]) {
        //filterByDate(it's already formatted in datepicker onchange)
        (async () => {
          /*setLoading(true);
          let payload = {
            tenantId: loginDetails?.tenantID,
            userId: selectedMember?.currentMemberDetails?.userId,
            customerId:
              selectedMember?.currentMemberDetails?.memberId ??
              selectedMember?.currentMemberDetails?.userId,
            userGroupId: selectedMember?.membershipId,
            transactionDate: format(new Date(filterByDate), 'yyyy-MM-dd'),
            offerType: filterByType,
            pageNumber: 0,
            pageSize: 100,
          };
          await dispatch(getAllClaimedOffer(payload)).unwrap();
          setLoading(false);*/
          const {data, loading, error} = await dispatch(
            getAllClaimedOffer({
              tenantId: loginDetails?.tenantID,
              userId: selectedMember?.currentMemberDetails?.userId,
              ...(CDP_ALLOWED_TENANT_ID.includes(String(loginDetails?.tenantID))
                ? {
                    customerId: selectedMember?.currentMemberDetails?.memberId ?? null,
                  }
                : {
                    customerId:
                      selectedMember?.currentMemberDetails?.memberId ??
                      selectedMember?.currentMemberDetails?.userId,
                  }),
              userGroupId: selectedMember?.membershipId,
              transactionDate: format(new Date(filterByDate), 'yyyy-MM-dd'),
              offerType: filterByType,
              pageSize: pageSize,
              pageNumber: pageNo,
            }),
          ).unwrap();
          _handleResponse(data?.getAllClaimedOffer?.[0], loading, error);
        })();
      }
    }
  }, [filterByType, filterByDate, selectedMember?.currentMemberDetails, pageNo, pageSize]);

  return (
    <>
      <Wrapper>
        {!deatilView ? (
          <Fragment>
            <TabHeading
              data={TRANSACTIONSLOG}
              addOn={<RefreshButton image={artifacts.refresh} refresh={refresh} />}
            />
            {/* Mirrors the "AST Console Revamp" mockup's `.search-form` treatment
                (a compact, gapped row) rather than fields stretched edge-to-edge. */}
            <div
              style={{
                marginTop: 24,
                display: 'flex',
                flexWrap: 'wrap',
                gap: 24,
                alignItems: 'flex-end',
                maxWidth: 640,
              }}>
              <CustomTextInput
                // disabled={filterDisabled}
                inline
                label={TRANSACTIONSLOG.filter_label}
                name="filter"
                filterMenu={txn}
                value={filterByType}
                onChange={(e) => {
                  setFilterByType(e.target.value);
                  resetPage();
                }}
              />
              <CustomDatePicker
                date={filterByDate}
                handleChange={(searchDate) => {
                  setFilterByDate(searchDate);
                  resetPage();
                }}
                label={TRANSACTIONSLOG.date_search_label}
                flex={0.3}
              />
            </div>

            {/* FIlter option  */}

            {loading ? <Skeleton active paragraph={{rows: 6}} /> : ''}

            <div>
              {/* original had sx={{overflow: 'overflow'}} — not a valid CSS value, so it
                  was a no-op (effectively default `visible`); omitted rather than guessing intent */}
              {!loading ? (
                error ? (
                  <SnackBar
                    errorMessage={error}
                    isSnackBarOpen={isSnackBarOpen}
                    closeSnackBar={closeSnackBar}
                  />
                ) : transactions.length ? (
                  <InfiniteScrollerCustom
                    dataLength={transactions.length}
                    next={() => nextPage()}
                    hasMore={transactions.length < totalResults}>
                    <Flex vertical gap={16} style={{marginTop: 24}} tabIndex={0}>
                      {renderLogCard()}
                    </Flex>
                  </InfiniteScrollerCustom>
                ) : (
                  <NoResults text={TRANSACTIONSLOG.no_results_text} />
                )
              ) : null}
            </div>
          </Fragment>
        ) : (
          <>
            <TransactionDetails
              selectedTransaction={selectedTransaction}
              selectedOffer={selectedOffer}
              toggleView={() => {
                setDetailView(false);
              }}
            />
          </>
        )}
      </Wrapper>
    </>
  );
};

export default TabTransactionLogs;
